function changeLanguage(lang) {
  return {
    type: 'RECEIVE_CHANGE_LANGUAGE',
    current: lang,
  };
}

export default {
  changeLanguage,
};
